import { render, staticRenderFns } from "./ServiceInquiry.vue?vue&type=template&id=27fcdb89&scoped=true"
import script from "./ServiceInquiry.vue?vue&type=script&lang=js"
export * from "./ServiceInquiry.vue?vue&type=script&lang=js"
import style0 from "./ServiceInquiry.vue?vue&type=style&index=0&id=27fcdb89&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fcdb89",
  null
  
)

export default component.exports